import { manipulateLocalStorage } from './manipulateLocaleStorage'

export const getAuthLocaleStorage = () => {
  const existingValue = localStorage?.getItem?.('auth')
  return existingValue ? JSON?.parse?.(existingValue) : {}
}

export const setAuthLocaleStorage = (value: any) => {
  manipulateLocalStorage('auth', value)
}

export const removeAuthLocaleStorageKeys = (keys: string[]) => {
  const resultObject = keys.reduce(
    (acc: { [key: string]: undefined }, key: string) => {
      acc[key] = undefined
      return acc
    },
    {}
  )

  manipulateLocalStorage('auth', resultObject)
}

export const removeAuthLocalStorage = () => {
  manipulateLocalStorage('auth')
}
